import React from 'react';

const BreakButtons = (props) => {
    const {breakTimeHandler} = props;

    const breaks = [10, 20, 30, 40, 50];

    return (
        <div>
            <h2 className="mt-5 text-lg ">Add a break</h2>
            <div className="border-lime-500 border-2 bg-lime-100 rounded-md p-4 grid grid-cols-2 lg:grid-cols-4 gap-1">
                {
                    breaks.map((brk, index) => <button key={index} onClick={() => breakTimeHandler(+brk)} className="bg-lime-400 rounded-full p-3 text-sm">{brk}m</button>)
                }
            </div>
        </div>
    );
};

export default BreakButtons;